import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import BoldLabelAndContent from '../../molecules/BoldLabelAndContent'
import clsx from 'clsx'
import FullHeightConnector from '../../atoms/FullHeightConnector'
import { Step, StepLabel, Stepper } from '@material-ui/core'
import { useIconStyles, trackingStepColors } from '../../../utils/customStyles'
import DetailGeneralRules from '../procedures/DetailGeneralRules'
import { compareByCompleteDate } from '../../../utils/helpers'

const ProcedureGeneralInfo = ({ procedure }) => {
  const classes = useIconStyles()
  const colors = trackingStepColors()
  const activeStep = procedure.states.length - 1
  const isLastState = index => activeStep === index
  const statesList = useMemo(() => {
    return procedure.states.sort(compareByCompleteDate)
  }, [procedure.states])
  return (
    <div className="flex flex-col">
      <div className="bg-neutral-100 p-4 md:p-6">
        <div className="text-lg">
          Código de solicitud: <span className="font-bold">{procedure.code}</span>
        </div>
      </div>
      <div className="border-2 border-neutral-100 p-4 md:p-6">
        <BoldLabelAndContent label="Trámite:" content={procedure.name} className="flex flex-col" />
        <BoldLabelAndContent
          label="Nombre del solicitante:"
          content={procedure.citizen_fullname}
          className="flex flex-col mt-3"
        />
        <BoldLabelAndContent label="Fecha de envío:" content={procedure.created_at} className="flex flex-col mt-3" />
      </div>
      <div className="p-4 md:p-6 bg-neutral-100">
        <div className="text-xl font-bold mb-2">Avance</div>
        <Stepper
          className={'bg-neutral-100'}
          activeStep={activeStep}
          orientation="vertical"
          connector={<FullHeightConnector />}
        >
          {statesList.map((state, index) => (
            <Step key={index}>
              <StepLabel
                classes={{ root: 'items-start' }}
                StepIconComponent={() => (
                  <div
                    className={clsx(
                      isLastState(index) && !procedure.is_ended ? colors[state.color] : colors.success,
                      classes.root
                    )}
                  />
                )}
              >
                <div className="text-lg leading-tight mb-2">{state.name}</div>
                <div className="text-xs text-gray-500 font-normal">{state.date}</div>
              </StepLabel>
            </Step>
          ))}
          {!procedure.is_ended && (
            <Step>
              <StepLabel StepIconComponent={() => <div className={clsx(colors.gray, classes.root)} />}></StepLabel>
            </Step>
          )}
        </Stepper>
        <DetailGeneralRules rules={procedure.rules} />
      </div>
    </div>
  )
}
export default ProcedureGeneralInfo

ProcedureGeneralInfo.propTypes = {
  procedure: PropTypes.object
}
